<template>
    <div class="container" v-if="projeto">

        <div class="simulator-box card-panel">

            <h2 class="simulator-title" :class="{loaded: projeto, 'with-animation' : carregando}">Projeto: {{ projeto.nome }}</h2>

            <input-simulador input-type="price" label="Qual é o valor necessário para a conclusão do seu projeto futuro?" @input="salvar" v-model="projeto.valor_necessario" />

            <input-simulador input-type="number" label="Qual é o tempo (anos) necessário para a concretização do mesmo?" @input="salvar" v-model="projeto.tempo_necessario" />

            <input-simulador input-type="price" label="Qual é o valor que já tem reservado, no momento, para o mesmo?"  v-model.number="projeto.valor_reserva" />

            <total-simulador label="VALOR RESTANTE" :value="resto" />

        </div>


        <div class="simulator-box card-panel">

            <p>
                <strong>Aporte mensal necessário para a realização desse objetivo</strong>
            </p>


            <div class="flex-row item-checkbox" v-for="(valor, index) in rentabilidadesPadroes" :key="index">
                <div class="col-xs">
                    <input @change="salvar" :id="`rent-${index}`" name="rentabilidade_estimada" type="radio" :value="valor" v-model="rentabilidade_estimada" :disabled="valoresRentabilidadesPadroes[index] <= 0" />
                    <label :for="`rent-${index}`">{{ valor }}%</label>
                </div>
                <div class="col-xs" :class="{'text-active' : rentabilidade_estimada == valor}">
                    <template v-if="valoresRentabilidadesPadroes[index] > 0">
                        {{ valoresRentabilidadesPadroes[index] | dinheiro }}
                    </template>
                    <span v-else class="red-text lighten-3">
                        Você não precisa fazer um investimento mensal.
                    </span>
                </div>
            </div>

            <div class="flex-row item-checkbox">
                <div class="col-xs">
                    <input id="rent-outros" name="rentabilidade_estimada" type="radio" :checked="!rentabilidadesPadroes.includes(rentabilidade_estimada)" />
                    <label for="rent-outros">
                        <input @input="salvar" type="number" id="input-rentabilidade" v-model="rentabilidade_estimada" class="form-control" min="1" max="100">%
                    </label>
                </div>
                <div class="col-xs">
                    <span v-if="aporte > 0 && rentabilidade_estimada > 0" :class="{'text-active' : rentabilidadePersonalidada}">
                        {{ aporte | dinheiro }}
                    </span>
                    <span v-else class="red-text lighten-3">
                        Você não precisa fazer um investimento mensal.
                    </span>
                </div>
            </div>

        </div>
            <div class="simulator-box without-padding  input-field end-xs">
                <a :disabled="carregando" class="btn btn-default" @click="concluir">
                    {{ carregando ? 'Salvando...' : 'Voltar' }}
                </a>
            </div>


    </div>
</template>


<script>

import {api} from "@/helpers/api";
import "@/../static/assets/css/custom/flex.css";
import debounce from "lodash/debounce";

import InputSimulador from '@/components/common/InputSimulador.vue';
import TotalSimulador from '@/components/common/TotalSimulador.vue';
import SvgPercentage from '@/components/common/svg/SvgPercentage.vue';

import calculadora from '@/helpers/calculadora.js';
import FooterSimulador from "@/components/common/FooterSimulador.vue";

import { presente_value, pgto, taxa_efetiva_mensal } from "@/helpers/calculo_financeiro"


export default {

    components: {InputSimulador, SvgPercentage, TotalSimulador, FooterSimulador},
    name: 'projeto',

    async created() {

        const {cliente_id, projeto_id} = this.$route.params;

        let {data: {result: {data: projeto}}} = await api.get(`projeto/${projeto_id}`);


        [
            'valor_necessario',
            'tempo_necessario',
            'valor_reserva',
            'rentabilidade_estimada',
            'necessidade_investimento'
        ].forEach(key => {
            if (projeto) projeto[key] = parseFloat(projeto[key]);
        })

        this.rentabilidade_estimada = projeto.rentabilidade_estimada;

        this.projeto = projeto;

    },


    computed: {

        rentabilidadePersonalidada()
        {
            return ! this.rentabilidadesPadroes.includes(this.rentabilidade_estimada);
        },

        aporte() {
            return this.calcularRentabilidadeEstimada(this.rentabilidade_estimada);
        },

        rentabilidadesPadroes() {
            return [3, 4, 6];
        },

        valoresRentabilidadesPadroes() {
            return this.rentabilidadesPadroes.map(v => this.calcularRentabilidadeEstimada(v));
        },

        resto() {

            const tx = taxa_efetiva_mensal(this.rentabilidade_estimada)
            const nper = (90 - this.projeto.tempo_necessario) * 12;
            const pv = presente_value(tx, nper, this.projeto.valor_necessario)

            return this.projeto.valor_necessario - this.projeto.valor_reserva;

            return pv;
        },
    },

    data() {
        return {

            projeto: null,
            carregando: false,
            rentabilidade_estimada: null,
        };
    },

    methods: {


        calcularRentabilidadeEstimada(rentabilidade)
        {
            const tx               = taxa_efetiva_mensal(rentabilidade);
            let   prazo_acumulacao = this.projeto.tempo_necessario * 12;

            return -pgto(prazo_acumulacao, tx, -this.projeto.valor_reserva, this.resto)
        },


        concluir() {

            if (! this.projeto.projeto_id) return;

            this.salvar();


            this.$router.push({name: 'cliente_projetos', params: {id: this.projeto.cliente_id}})
        },

        salvar: debounce(async function() {


            if (this.aporte < 0 || this.resto < 0 || this.rentabilidade_estimada <= 0) return;

            this.carregando = true;


            const projeto = {...this.projeto, necessidade_investimento: this.aporte}

            try{
                await api.put(`projeto/${projeto.projeto_id}`, projeto);
            } finally {

                setTimeout(() => this.carregando = false, 2000);
            }

        }, 500)
    },

    watch: {

        rentabilidade_estimada(valor, anterior) {
            this.projeto.rentabilidade_estimada = valor;
        }
    }
}
</script>


<style lang="scss">

#input-rentabilidade{

    margin: 0;
    height: auto;
    width: 40px;
    padding: 5px;


    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
}

.text-active{
    color: var(--color-primary);
    font-weight: bold;
}

.item-checkbox{
    padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/clientes/Projeto.vue